// Shared options for whole-vehicle Goods Transport bookings.
// Separate from passenger rides and small parcel delivery.

export const GOODS_TRANSPORT_TYPES = [
  "Fridge",
  "Furniture",
  "Groceries",
  "Electronics",
  "Home Shifting",
  "Agricultural Goods",
  "Construction Materials",
  "Business Goods",
  "Other",
] as const;

export const GOODS_TRANSPORT_VEHICLES = [
  "Auto",
  "Mini Pickup",
  "Pickup",
  "Tractor + Trailer",
  "Power Tiller + Trailer",
  "Truck",
  "Heavy Trailer",
] as const;

export type GoodsTransportType =
  (typeof GOODS_TRANSPORT_TYPES)[number];

export type GoodsTransportVehicle =
  (typeof GOODS_TRANSPORT_VEHICLES)[number];

export function isGoodsTransportType(
  value: unknown
): value is GoodsTransportType {
  return (
    typeof value === "string" &&
    GOODS_TRANSPORT_TYPES.some((item) => item === value)
  );
}

export function isGoodsTransportVehicle(
  value: unknown
): value is GoodsTransportVehicle {
  return (
    typeof value === "string" &&
    GOODS_TRANSPORT_VEHICLES.some((item) => item === value)
  );
}
